/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { GridLayout } from "../assets/icons";
import { UnorderedListOutlined } from "@ant-design/icons";

export const ViewSwitch = ({ onChange, value }) => {
  const getViewStyle = (targetView) =>
    value === targetView ? "view_switch__item__active" : "";

  return (
    <div className="view_switch">
      <div className={`view_switch__item ${getViewStyle("LIST")} `}>
        <UnorderedListOutlined
          onClick={() => {
            onChange("LIST");
          }}
        />
      </div>

      <div className={`view_switch__item ${getViewStyle("GRID")}`}>
        <GridLayout onClick={() => onChange("GRID")} />
      </div>
    </div>
  );
};
